module.exports = __webpack_public_path__ + "r-v3/img/lock_blue.518e9695.svg";